@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.popup-container {
  &.covering {
    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 1000;
    background: rgba(255, 255, 255, 0.9);
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;

    .popup-card {
      animation: unset;
      position: unset;
      z-index: unset;
    }
  }

  .popup-card {
    animation: slideIn 1s ease;
    position: fixed;
    z-index: 1000;
    border-radius: 8px;
    bottom: 1em;
    max-height: 480px;
    width: 360px;
    filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.1));
    background-color: colors.$primary-background-color;
    margin-left: 20px;
    margin-right: 20px;

    left: calc((100vw - 360px)/2);
    @include responsive.tablet-and-up {
      left: 1.25em;
    }

    .logo {
      max-height: 200px;
      overflow-y: hidden;
      display: flex;
      border-radius: 8px 8px 0 0;

      svg {
        display: flex;
        align-self: center;
        width: 360px;
        height: auto;

        @include responsive.phone {
          width: 100%;
        }
      }
    }

    .sla-img-container {
      .logo-cover > svg {
        position: absolute;
        top: calc((188px - 84px)/ 2);
        left: calc((360px - 78px) / 2);
      }
      img {
        border-radius: 8px 8px 0 0;
        max-width: 100%;
        object-fit: cover;
      }
    }

    .copy {
      margin: 28px 20px 20px;
      text-align: left;

      p {
        font-size: 16px;
        margin-top: 1em; // 16px
        margin-bottom: 0;
      }

      &.onboarding h3 {
        max-width: 320px;
        margin: 28px 0 20px;
        font-weight: 900;
        line-height: 26px;
      }
    }
  }
}

@keyframes slideIn {
  0% {
    transform: translateY(480px);
  }
  100% {
    transform: translateY(0);
  }
}
